import Analytics, { type AnalyticsInstance } from 'analytics'
import { eventValidationPlugin } from './plugins'
import { POSTHOG_WIDGET_APPS, LINKS, TOKENS } from './consts'
import type { Mode } from '@/types'
import postHog from '@metro-fs/analytics-plugin-posthog'
import isWebview from 'is-ua-webview'

export type PosthogInstance = AnalyticsInstance & {
    plugins: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        'posthog': any
    }
}

export function setupPosthog(partyId: string, workflowName: string, mode: Mode, clientDomain?: string): PosthogInstance {
    const posthog = Analytics({
        app: 'posthog-analytics',
        plugins: [
            eventValidationPlugin({
                context: 'widget',
                widgetApps: POSTHOG_WIDGET_APPS,
                mode,
            }),
            postHog({
                token: TOKENS[mode],
                enabled: true,
                options: {
                    api_host: LINKS[mode],
                    autocapture: false,
                    advanced_disable_decide: true,
                    debug: mode === 'staging',
                    respect_dnt: false,
                    request_batching: true,
                    capture_pageview: false,
                },
            }),
        ],
    }) as PosthogInstance

    const userProps = {
        distinct_id: partyId,
        party_id: partyId,
        workflow_name: workflowName,
        is_webview: isWebview(window.navigator.userAgent),
        client_domain: clientDomain,
    }

    posthog.identify(partyId, userProps)

    posthog.ready(() => {
        posthog.plugins.posthog.register({ payload: userProps })
    })

    return posthog
}
